module.exports = __webpack_public_path__ + "static/img/ico_nav_news.99673cfa.png";